import inView from 'in-view';

export default class InView {
    constructor() {
        inView('[data-inview]').on('enter', el => {
            el.classList.add('inview');
        });
        inView.offset(150);
    }
}